import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { apiFetch } from '../lib/api'

export default function BlogPostPage() {
  const { slug } = useParams()
  const [blog, setBlog] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let mounted = true

    async function loadBlog() {
      try {
        const res = await apiFetch(`/blogs/${slug}`)
        const data = await res.json()
        if (!res.ok) throw new Error(data.message || 'Failed to load blog.')
        if (mounted) {
          setBlog(data)
          setError('')
          document.title = `${data.title} - Co-Eater Blog`
        }
      } catch (err) {
        if (mounted) {
          setError(err.message || 'Failed to load blog.')
          document.title = 'Blog - Co-Eater'
        }
      } finally {
        if (mounted) setLoading(false)
      }
    }

    loadBlog()
    return () => {
      mounted = false
    }
  }, [slug])

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 px-4 py-6 sm:px-8">
      <article className="mx-auto max-w-3xl rounded-3xl border border-orange-100 bg-white/85 p-6 shadow-sm sm:p-8">
        <div className="flex w-full items-center justify-between">
  <Link to="/blogs" className="text-sm font-semibold text-orange-600 hover:text-orange-700">
    ← Back to Blogs
  </Link>
  <Link to="/" className="text-sm font-semibold text-gray-600 hover:text-gray-700">
    Co-Eater
  </Link>
</div>

        {loading && <p className="mt-4 text-sm text-gray-600">Loading blog...</p>}

        {!loading && error && <p className="mt-4 text-sm text-red-600">{error}</p>}

        {!loading && !error && blog && (
          <>
            <h1 className="mt-4 title-font text-3xl font-extrabold text-gray-900">{blog.title}</h1>
            <p className="mt-2 text-xs text-gray-500">
              {blog.author || 'Co-Eater Team'}
              {' · '}
              {blog.publishedAt
                ? new Date(blog.publishedAt).toLocaleDateString()
                : new Date(blog.createdAt).toLocaleDateString()}
            </p>

            {blog.imageUrl && (
              <img
                src={blog.imageUrl}
                alt={blog.title}
                className="mt-5 h-60 w-full rounded-2xl object-cover sm:h-72"
              />
            )}

            {blog.excerpt && (
              <p className="mt-5 text-base font-medium leading-relaxed text-gray-700">{blog.excerpt}</p>
            )}

            <div className="prose prose-sm mt-5 max-w-none whitespace-pre-wrap break-words text-gray-700">
              {blog.content}
            </div>
          </>
        )}
      </article>
    </div>
  )
}
